import { Dialog, DialogContent, DialogTitle } from '~/shadcn/ui/dialog'
import { type MonthlyReportXlsxExportParams } from '~/@biz_ambassador/ambassador/useAmbassadorData'
import { ExportTable } from './ExportTable'
import type { ExportMonth } from './export.utils'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  downloadingKey: string | null
  months: Array<ExportMonth>
  exportHandler: (params: MonthlyReportXlsxExportParams) => Promise<void>
}

export function ExportDialog({
  open,
  onOpenChange,
  downloadingKey,
  months,
  exportHandler,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[min(30rem, 600px] w-full gap-10 px-6 md:px-15 pt-12 pb-13">
        <div className="flex flex-col items-center gap-5 text-center">
          <DialogTitle className="text-2xl font-semibold">
            Stiahnuť XLSX report
          </DialogTitle>
        </div>

        <ExportTable
          months={months}
          downloadingKey={downloadingKey}
          onDownload={exportHandler}
        />
      </DialogContent>
    </Dialog>
  )
}
